/**
 * Generated bundle index. Do not edit.
 */

export {PresetType,providePreset,providePresetFor,provideComponents,PRESET_METADATA_KEY,PresetMetadata,PresetMetadataOptions,setPresetMetadataOn,getPresetMetadataFrom,Preset,PresetService,PresetModule,PresetDefaultModule} from './public_api';
